var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSb = function SvgIconSb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M20.486 20.485c4.5-4.5 4.679-11.686.535-16.4L12.001 12 4.087 21.02c4.714 4.143 11.899 3.966 16.4-.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.514 3.514c4.5-4.5 11.686-4.678 16.4-.535L12 12l-9.02 7.914c-4.144-4.714-3.966-11.9.534-16.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.914 2.98 2.979 19.915a12 12 0 0 0 1.107 1.106L21.021 4.087a12 12 0 0 0-1.107-1.107"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.056 4.174.26.798h.837l-.678.492.26.797-.679-.492-.678.492.26-.797-.679-.492h.838zM9.337 4.174l.26.797h.838l-.678.492.259.798-.679-.493-.678.493.26-.798-.679-.492h.838zM5.056 8.348l.26.797h.837l-.678.493.26.797-.679-.493-.678.493.26-.797-.679-.493h.838zM9.337 8.348l.26.797h.838l-.678.493.259.797-.679-.493-.678.493.26-.797-.679-.493h.838zM7.197 6.262l.259.797h.838l-.678.493.259.797-.678-.493-.678.493.259-.797-.678-.493h.838z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSb;